function newId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `ob-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

function _normalizeColumnCount(v) {
  const n = Number(v);
  if (n === 1 || n === 2 || n === 3) return n;
  return 2;
}

export function parseColumnsRow(text) {
  try {
    const o = JSON.parse(text || "{}");
    const n = _normalizeColumnCount(o.columnCount);
    let cells = Array.isArray(o.cells) ? o.cells : [];
    while (cells.length < n) cells.push([]);
    cells = cells.slice(0, n).map((c) => (Array.isArray(c) ? c : []));
    return { columnCount: n, cells };
  } catch (_) {
    return { columnCount: 2, cells: [[], []] };
  }
}

export function stringifyColumnsRow({ columnCount, cells }) {
  const n = _normalizeColumnCount(columnCount);
  const c = [...(cells || [])];
  while (c.length < n) c.push([]);
  return JSON.stringify({ columnCount: n, cells: c.slice(0, n) });
}

export function emptyColumnsRow(columnCount = 2) {
  const n = _normalizeColumnCount(columnCount);
  const cells = Array.from({ length: n }, () => []);
  return stringifyColumnsRow({ columnCount: n, cells });
}

/** Inserta un widget vacío mínimo en una columna (texto). */
export function appendWidgetToColumn(text, columnIndex, widget) {
  const d = parseColumnsRow(text);
  const idx = Math.max(0, Math.min(d.columnCount - 1, columnIndex));
  const cells = d.cells.map((col, i) => (i === idx ? [...col, widget] : col));
  return stringifyColumnsRow({ columnCount: d.columnCount, cells });
}

export function cloneWidgetTree(w) {
  const nw = JSON.parse(JSON.stringify(w));
  nw.id = newId();
  if (nw.type === "columns_row") {
    const d = parseColumnsRow(nw.text);
    const cells = d.cells.map((col) => col.map((c) => cloneWidgetTree(c)));
    nw.text = stringifyColumnsRow({ columnCount: d.columnCount, cells });
  }
  return nw;
}

/** Cambia el número de columnas (1, 2 o 3); conserva widgets fusionando columnas sobrantes. */
export function setColumnsRowColumnCount(text, columnCount) {
  const d = parseColumnsRow(text);
  let cells = [...d.cells.map((c) => [...(c || [])])];
  const n = _normalizeColumnCount(columnCount);
  while (cells.length < n) cells.push([]);
  while (cells.length > n) {
    const last = cells.pop() || [];
    if (cells.length) cells[cells.length - 1] = [...cells[cells.length - 1], ...last];
  }
  return stringifyColumnsRow({ columnCount: n, cells: cells.slice(0, n) });
}
